import {
  createContext,
  useCallback,
  useContext,
  useMemo,
  useState,
  type ReactNode,
} from "react";

interface PreferencesUIContextValue {
  open: boolean;
  setOpen: (open: boolean) => void;
  openPreferences: () => void;
  closePreferences: () => void;
}

const PreferencesUIContext = createContext<PreferencesUIContextValue | null>(
  null,
);

export function PreferencesUIProvider({ children }: { children: ReactNode }) {
  const [open, setOpen] = useState(false);

  const openPreferences = useCallback(() => setOpen(true), []);
  const closePreferences = useCallback(() => setOpen(false), []);

  const value = useMemo(
    () => ({
      open,
      setOpen,
      openPreferences,
      closePreferences,
    }),
    [open, openPreferences, closePreferences],
  );

  return (
    <PreferencesUIContext.Provider value={value}>
      {children}
    </PreferencesUIContext.Provider>
  );
}

export function usePreferencesUI() {
  const ctx = useContext(PreferencesUIContext);
  if (!ctx) {
    throw new Error("usePreferencesUI must be used within PreferencesUIProvider");
  }
  return ctx;
}
